import { put, takeEvery, } from 'redux-saga/effects';
import { setCustomerName, SET_CUSTOMER_NAME_SAGA } from './action';

export function* callSetCustomerName(action){
   yield put(setCustomerName(action.payload));
}
export function* watchSetCustomerName(){
    yield takeEvery (SET_CUSTOMER_NAME_SAGA,callSetCustomerName);
}